<page-wrapper>
  <router-outlet></router-outlet>
</page-wrapper>
